import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-invoices-summary",
  templateUrl: "./dash-invoices-summary.component.html",
  styleUrls: ["./dash-invoices-summary.component.sass"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashInvoicesSummaryComponent implements OnInit {
  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(private readonly store: Store) {}

  ngOnInit(): void {}
}
